/**
 * Broker display helpers — keeps brand colour mapping in one place.
 *
 * Supported colored variants:
 *   - IBKR (Interactive Brokers) → red
 *   - T212 (Trading 212)         → blue
 *   - anything else              → neutral grey ("default")
 */

export function brokerBadgeClass(broker) {
  const b = String(broker || '').toUpperCase().trim();
  if (!b || b === '-') return 'broker-badge default';
  if (b === 'IBKR' || b.includes('INTERACTIVE')) return 'broker-badge ibkr';
  if (b === 'T212' || b.includes('TRADING 212') || b.includes('TRADING212')) {
    return 'broker-badge t212';
  }
  return 'broker-badge default';
}

export function brokerLabel(broker) {
  const b = String(broker || '').trim();
  return b || '-';
}
